import { handleActions } from 'redux-actions';
import { AccountSettingsStoreSlice } from './types';
import { initDeactivationStatus } from './actions';
import { defaultDeactivationState } from './defaults';

export const deactivationStatusReducer = handleActions<
  AccountSettingsStoreSlice['deactivationStatus'],
  any
>(
  {
    [initDeactivationStatus.toString()]: (
      state,
      action: ReturnType<typeof initDeactivationStatus>
    ) => ({
      ...defaultDeactivationState,
      ...state,
      ...action.payload.status,
    }),
  },
  defaultDeactivationState
);
